import gql from 'graphql-tag';

export const gqlGetQuery = gql`
  query getMailsrepo($limit: Int, $offset: Int, $order: String, $where: String) {
    getMailsrepo(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        originatedFrom
        from
        to
        cc
        subject
        text
        html
        composedDate
        sendDate
        failedDate
        failedReason
        failedDetails
        isDeleted
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getMailsrepoById($id: Int) {
    getMailsrepoById(id: $id) {
      id
      originatedFrom
      from
      to
      cc
      subject
      text
      html
      composedDate
      sendDate
      failedDate
      failedReason
      failedDetails
      isDeleted
    }
  }
`;

export const gqlClearUnsendMailsMutation = gql`
  mutation clearUnsendMails {
    clearUnsendMails
  }
`;

export const gqlRestoreMailMutation = gql`
  mutation restoreMail($id: Int) {
    updateMailsrepo(data: { id: $id, isDeleted: 0 }) {
      id
      isDeleted
    }
  }
`;

export const gqlRetryFailedMailMutation = gql`
  mutation retryFailedMail($id: Int) {
    retryFailedMail(id: $id) {
      id
      sendDate
      failedDate
      failedReason
      failedDetails
    }
  }
`;
